import { render, staticRenderFns } from "./Activities.vue?vue&type=template&id=68868247&scoped=true&"
import script from "./Activities.vue?vue&type=script&lang=ts&"
export * from "./Activities.vue?vue&type=script&lang=ts&"
import style0 from "./Activities.vue?vue&type=style&index=0&id=68868247&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68868247",
  null
  
)

export default component.exports